/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicator', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorDataCopySettings', 'model/PerformanceIndicatorDataExtrapolationSettings', 'model/PerformanceIndicatorReport', 'model/PerformanceIndicatorAvailabilityReport', 'model/PerformanceIndicatorDataReport', 'model/CorporateStructureLink', 'model/PerformanceIndicatorDrillData'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicator'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorDataCopySettings'), require('../model/PerformanceIndicatorDataExtrapolationSettings'), require('../model/PerformanceIndicatorReport'), require('../model/PerformanceIndicatorAvailabilityReport'), require('../model/PerformanceIndicatorDataReport'), require('../model/CorporateStructureLink'), require('../model/PerformanceIndicatorDrillData'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicator, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorDataCopySettings, root.ForStractionServiceApi.PerformanceIndicatorDataExtrapolationSettings, root.ForStractionServiceApi.PerformanceIndicatorReport, root.ForStractionServiceApi.PerformanceIndicatorAvailabilityReport, root.ForStractionServiceApi.PerformanceIndicatorDataReport, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.PerformanceIndicatorDrillData);
  }
}(this, function(ApiClient, PerformanceIndicator, PerformanceIndicatorDataFilter, PerformanceIndicatorDataCopySettings, PerformanceIndicatorDataExtrapolationSettings, PerformanceIndicatorReport, PerformanceIndicatorAvailabilityReport, PerformanceIndicatorDataReport, CorporateStructureLink, PerformanceIndicatorDrillData) {
  'use strict';

  /**
   * PerformanceIndicator service.
   * @module api/PerformanceIndicatorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorApi. 
   * @alias module:api/PerformanceIndicatorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorAddAfterIndicatorPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorAddAfterIndicatorPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAfterIndicator
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicator} body 
     * @param {Integer} baseIndicatorID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorAddAfterIndicatorPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorAddAfterIndicatorPut = function(_4SAPIAppID, body, baseIndicatorID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorAddAfterIndicatorPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorAddAfterIndicatorPut";
      }

      // verify the required parameter 'baseIndicatorID' is set
      if (baseIndicatorID == undefined || baseIndicatorID == null) {
        throw "Missing the required parameter 'baseIndicatorID' when calling performanceIndicatorAddAfterIndicatorPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'baseIndicatorID': baseIndicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicator/addAfterIndicator', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorAddBeforeIndicatorPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorAddBeforeIndicatorPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addBeforeIndicator
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicator} body 
     * @param {Integer} baseIndicatorID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorAddBeforeIndicatorPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorAddBeforeIndicatorPut = function(_4SAPIAppID, body, baseIndicatorID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorAddBeforeIndicatorPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorAddBeforeIndicatorPut";
      }

      // verify the required parameter 'baseIndicatorID' is set
      if (baseIndicatorID == undefined || baseIndicatorID == null) {
        throw "Missing the required parameter 'baseIndicatorID' when calling performanceIndicatorAddBeforeIndicatorPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'baseIndicatorID': baseIndicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicator/addBeforeIndicator', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorAddFinancialIndicatorPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorAddFinancialIndicatorPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addFinancialIndicator
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicator} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorAddFinancialIndicatorPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorAddFinancialIndicatorPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorAddFinancialIndicatorPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorAddFinancialIndicatorPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicator/addFinancialIndicator', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorAddPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicator} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.performanceIndicatorAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/PerformanceIndicator/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorCalculateIndicatorsDataGet operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorCalculateIndicatorsDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * calculateIndicatorsData
     * @param {String} _4SAPIAppID 
     * @param {Boolean} calculateChanged 
     * @param {Integer} calculationRange 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorCalculateIndicatorsDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorCalculateIndicatorsDataGet = function(_4SAPIAppID, calculateChanged, calculationRange, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorCalculateIndicatorsDataGet";
      }

      // verify the required parameter 'calculateChanged' is set
      if (calculateChanged == undefined || calculateChanged == null) {
        throw "Missing the required parameter 'calculateChanged' when calling performanceIndicatorCalculateIndicatorsDataGet";
      }

      // verify the required parameter 'calculationRange' is set
      if (calculationRange == undefined || calculationRange == null) {
        throw "Missing the required parameter 'calculationRange' when calling performanceIndicatorCalculateIndicatorsDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'calculateChanged': calculateChanged,
        'calculationRange': calculationRange
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/calculateIndicatorsData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorClearDataPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorClearDataPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clearData
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorClearDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorClearDataPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorClearDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorClearDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/clearData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorCopyDataPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorCopyDataPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * copyData
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataCopySettings>} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorCopyDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorCopyDataPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorCopyDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorCopyDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/copyData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDeleteGet operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDeleteGet = function(_4SAPIAppID, indicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDeleteGet";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorEditPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/PerformanceIndicator} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorExtrapolateDataPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorExtrapolateDataPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * extrapolateData
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataExtrapolationSettings>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.entryID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorExtrapolateDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorExtrapolateDataPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorExtrapolateDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorExtrapolateDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entryID': opts['entryID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/extrapolateData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorLoadAllGet operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorReport>}
     */
    this.performanceIndicatorLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorReport];

      return this.apiClient.callApi(
        '/PerformanceIndicator/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorLoadGet operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorReport}
     */
    this.performanceIndicatorLoadGet = function(_4SAPIAppID, indicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorLoadGet";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorReport;

      return this.apiClient.callApi(
        '/PerformanceIndicator/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorSearchAvailabilityReportPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorSearchAvailabilityReportPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorAvailabilityReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchAvailabilityReport
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorAvailabilityReport>} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorSearchAvailabilityReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorAvailabilityReport>}
     */
    this.performanceIndicatorSearchAvailabilityReportPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorSearchAvailabilityReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorSearchAvailabilityReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorAvailabilityReport];

      return this.apiClient.callApi(
        '/PerformanceIndicator/searchAvailabilityReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorSearchDataReportPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorSearchDataReportPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchDataReport
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorSearchDataReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDataReport>}
     */
    this.performanceIndicatorSearchDataReportPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorSearchDataReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorSearchDataReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDataReport];

      return this.apiClient.callApi(
        '/PerformanceIndicator/searchDataReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorSearchDrillDataPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorSearchDrillDataPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorDrillData} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchDrillData
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} indicatorID 
     * @param {Integer} periodTypeID 
     * @param {Date} periodStart 
     * @param {Date} periodEnd 
     * @param {Integer} pointCalculationID 
     * @param {Integer} dimensionID 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorSearchDrillDataPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorDrillData}
     */
    this.performanceIndicatorSearchDrillDataPut = function(_4SAPIAppID, body, indicatorID, periodTypeID, periodStart, periodEnd, pointCalculationID, dimensionID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'periodTypeID' is set
      if (periodTypeID == undefined || periodTypeID == null) {
        throw "Missing the required parameter 'periodTypeID' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'periodStart' is set
      if (periodStart == undefined || periodStart == null) {
        throw "Missing the required parameter 'periodStart' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'periodEnd' is set
      if (periodEnd == undefined || periodEnd == null) {
        throw "Missing the required parameter 'periodEnd' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'pointCalculationID' is set
      if (pointCalculationID == undefined || pointCalculationID == null) {
        throw "Missing the required parameter 'pointCalculationID' when calling performanceIndicatorSearchDrillDataPut";
      }

      // verify the required parameter 'dimensionID' is set
      if (dimensionID == undefined || dimensionID == null) {
        throw "Missing the required parameter 'dimensionID' when calling performanceIndicatorSearchDrillDataPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID,
        'periodTypeID': periodTypeID,
        'periodStart': periodStart,
        'periodEnd': periodEnd,
        'pointCalculationID': pointCalculationID,
        'dimensionID': dimensionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorDrillData;

      return this.apiClient.callApi(
        '/PerformanceIndicator/searchDrillData', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorSplitFinancialIndicatorToSubAccountsPut operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorSplitFinancialIndicatorToSubAccountsPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * splitFinancialIndicatorToSubAccounts
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicator>} body 
     * @param {Integer} parentIndicatorID 
     * @param {Boolean} calculateFinancialData 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorSplitFinancialIndicatorToSubAccountsPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorSplitFinancialIndicatorToSubAccountsPut = function(_4SAPIAppID, body, parentIndicatorID, calculateFinancialData, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorSplitFinancialIndicatorToSubAccountsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorSplitFinancialIndicatorToSubAccountsPut";
      }

      // verify the required parameter 'parentIndicatorID' is set
      if (parentIndicatorID == undefined || parentIndicatorID == null) {
        throw "Missing the required parameter 'parentIndicatorID' when calling performanceIndicatorSplitFinancialIndicatorToSubAccountsPut";
      }

      // verify the required parameter 'calculateFinancialData' is set
      if (calculateFinancialData == undefined || calculateFinancialData == null) {
        throw "Missing the required parameter 'calculateFinancialData' when calling performanceIndicatorSplitFinancialIndicatorToSubAccountsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'parentIndicatorID': parentIndicatorID,
        'calculateFinancialData': calculateFinancialData
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicator/splitFinancialIndicatorToSubAccounts', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorTestIndicatorFinancialFormulaGet operation.
     * @callback module:api/PerformanceIndicatorApi~performanceIndicatorTestIndicatorFinancialFormulaGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * testIndicatorFinancialFormula
     * @param {String} _4SAPIAppID 
     * @param {String} formula 
     * @param {module:api/PerformanceIndicatorApi~performanceIndicatorTestIndicatorFinancialFormulaGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.performanceIndicatorTestIndicatorFinancialFormulaGet = function(_4SAPIAppID, formula, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorTestIndicatorFinancialFormulaGet";
      }

      // verify the required parameter 'formula' is set
      if (formula == undefined || formula == null) {
        throw "Missing the required parameter 'formula' when calling performanceIndicatorTestIndicatorFinancialFormulaGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'formula': formula
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/PerformanceIndicator/testIndicatorFinancialFormula', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
